import { Telemetry } from '~commonInfra/services/Telemetry';
import {
  FavoriteItemOpenedEvent,
  TelemetryEvents
} from '~commonInfra/telemetryEvents/TelemetryEvents';
import { FavoriteItemType } from '~src/favorites/types/IFavorite';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

export function maybeSendTelemetry_favoriteItemOpened(item: IContentInfo<FavoriteItemType>) {
  if (item.favorite) {
    Telemetry.sendEvent<FavoriteItemOpenedEvent>({
      type: TelemetryEvents.FavoriteItemOpened,
      favoriteItemType: item.contentType,
      favoriteItemId: item.id,
    });
  }
}
